import * as service from './service'
export default {
  namespace: 'ActivityCenter',
  state: {
    activityCenterData: [],
    readNewAdData: {}
  },
  effects: {
    * getList ({ payload }, { call, put }) {
      const res = yield call(service.getList, payload)
      yield put({
        type: 'save',
        payload: {
          activityCenterData: res.data.data
        }
      })
      return res.data
    },
    * readNewAd ({ payload }, { call, put }) {
      const res = yield call(service.readNewAd, payload)
      yield put({
        type: 'save',
        payload: {
          readNewAdData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
